import { UPDATE as UPDATE_HUGGG, isTestHuggg } from './huggg';
import { huggg } from '@huggg/back-bar';

import initialStateLoader from '../initialState';
import AnalyticsService from 'services/AnalyticsService';

const analytics = new AnalyticsService();
const SUBMIT = 'huggg/redeem/SUBMIT';
const SUCCESS = 'huggg/redeem/SUCCESS';
const FAILURE = 'huggg/redeem/FAILURE';
const CLEAR_ERROR = 'huggg/redeem/CLEAR_ERROR';
export const VOUCHER_GENERATED = 'huggg/redeem/VOUCHER_GENERATED';

const { redeem: initialState } = initialStateLoader();

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SUBMIT:
      return { ...state, redeeming: true };

    case VOUCHER_GENERATED:
      return {
        ...state,
        isFirstRedeemed: true
      };

    case SUCCESS:
      return {
        ...state,
        redeeming: false,
        redemption: payload.redemption,
        isFirstRedeemed: true
      };

    case CLEAR_ERROR:
      return {
        ...state,
        redeemError: null
      };

    case FAILURE:
      return {
        ...state,
        redeeming: false,
        redeemError: payload.error
      };

    default:
      return state;
  }
};

export default reducer;

/**
 * SIDE EFFECTS
 */
export const redeemPin = (id, code) => (dispatch, getState) => {
  const { huggg: hugggState } = getState().huggg;

  dispatch({ type: SUBMIT, payload: {} });

  if (isTestHuggg(getState())) {
    dispatch({
      type: UPDATE_HUGGG,
      payload: {
        redemption: 'test-redemption',
        redeemed_id: 'test-redemption-id'
      }
    });

    return dispatch({
      type: SUCCESS,
      payload: { redemption: 'test-redemption' }
    });
  }

  return huggg
    .redeem(id, code)
    .then(data => {
      analytics.passiveCompleteHugggPinRedeem({
        hugggId: hugggState.id,
        brandId: hugggState.brand_id,
        brandName: hugggState.brand_name,
        productId: hugggState.purchase.id,
        productName: hugggState.purchase.label
      });
      dispatch({
        type: UPDATE_HUGGG,
        payload: {
          redemption: data,
          redeemed_id: data.id
        }
      });
      dispatch({
        type: SUCCESS,
        payload: { redemption: data }
      });
    })
    .catch(err => {
      dispatch({
        type: FAILURE,
        payload: { error: err }
      });
    });
};

/* ACTIONS */
export const clearRedeemError = () => dispatch =>
  dispatch({ type: CLEAR_ERROR });

/**
 * SELECTORS
 */
export const isRedeeming = ({ redeem }) => redeem.redeeming;
export const isFirstRedeemed = state => state.redeem.isFirstRedeemed;
export const getRedeemError = ({ redeem }) => redeem.redeemError;
